import { render, staticRenderFns } from "./RegisterStaff.vue?vue&type=template&id=59e829a0&scoped=true&"
import script from "./RegisterStaff.vue?vue&type=script&lang=js&"
export * from "./RegisterStaff.vue?vue&type=script&lang=js&"
import style0 from "./RegisterStaff.vue?vue&type=style&index=0&id=59e829a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e829a0",
  null
  
)

export default component.exports